
import { FetchError } from '../errors/FetchError'
import { fetchApiImageAuth2, fetchWithAuthorization } from './fetch'

export const postSurvey = async (condominium, body) => {
  try {
    const data = await fetchApiImageAuth2(`/voting/${condominium}`, body, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create survey failed')
  }
}

export const updateSurvey = async (condominium, body) => {
  try {
    const data = await fetchApiImageAuth2(`/voting/update/${body.get('id')}`, body, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create survey failed')
  }
}

export const getAllSurvey = async (page = 1, limit = 10, params) => {
  const { condominium, status, survey, search } = params
  try {
    let url = `/voting/${condominium}?limit=${limit}&page=${page}&voted=${status}&survey=${survey}&ASC=1`
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`

    const data = await fetchWithAuthorization(url, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to Create survey failed')
  }
}

export const findOneSurvey = async (voting) => {
  try {
    const data = await fetchWithAuthorization(`/voting/details/${voting}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to find survey failed')
  }
}

export const removeOptionSurvey = async (voting) => {
  try {
    const data = await fetchWithAuthorization(`/voting/option/${voting}`, {}, 'DELETE')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to remove option survey failed')
  }
}

export const findOneSurveyResult = async (voting) => {
  try {
    const data = await fetchWithAuthorization(`/voting/results/${voting}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to find survey failed')
  }
}

export const makeVote = async (option) => {
  try {
    const data = await fetchWithAuthorization(`/voting/property/${option}`, null, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to vote survey failed')
  }
}
